module.exports = __webpack_public_path__ + "img/cashapp.538dafb6.png";